import { PagerResponse, PagerParams } from 'src/app/core/dtos/pager';
import { Line } from '../lines';

export enum GroupStatus {
  GROUP_UNSET = 'GROUP_UNSET', // Do not use, needed because of proto3 limitations
  GROUP_ACTIVE = 'GROUP_ACTIVE',
  GROUP_TERMINATED = 'GROUP_TERMINATED',
}

export interface GetFilteredGroupsParams extends PagerParams {
  status?: GroupStatus[];
  names?: string[];
  lineIds?: string[];
  groupIds?: string[];
  groupExternalIds?: string[];
  brandId?: string;
  optFields: string[];
}

export interface GetFilteredGroupsResponse extends PagerResponse {
  groups: Group[];
}

export interface CreateGroupParams {
  name: string;
  description?: string;
  memberType: string;
  memberIds: string[];
  groupExternalIds?: string[];
  brandId?: string;
}

export interface UpdateGroupParams {
  groupId: string;
  name?: string;
  status?: GroupStatus;
  description?: string;
  groupExternalIds?: string;
  brandId?: string;
}

export interface UpdateGroupMembersParams {
  groupId: string;
  memberType: string;
  memberIds: string[];
  brandId?: string;
}

export interface UpdateGroupMembersResponse {
  lines: Line[];
}

export interface UpdateGroupsParams {
  groupIds: string[];
  status?: GroupStatus;
  brandId?: string;
}

export interface UpdateGroupsResponse {
  groups: Group[];
}

export interface GetGroupMembersParams {
  groupId: string;
  brandId?: string;
  optFields?: string[];
}

export interface GetGroupMembersResponse {
  lines: Line[];
}

export interface Group {
  groupId: string;
  status: GroupStatus;
  name: string;
  description?: string;
  memberCounts?: {
    [key: string]: number;
  };
  groupExternalId?: string;
  createdTs?: Date;
  modifiedTs?: Date;
  terminatedTs?: Date;
  brandId: string;
}
